<template>
	<div class="safe">
	  <div class="header">
	  	<div class="header-layout">
	  		<h1 class="logo" id="logo">
	  			<a href="http://www.ddzzii.com"></a>
	  		</h1>
	  		<a class="logo-title"> {{ivActionType}} </a>
	  		<ul class="header-nav">
	  			<li class="li-first">
	  				<a href="">注册</a>
	  			</li>
	  			<li>
	  				<a href="">登录</a>
	  			</li>
	  			<li>
	  				<a href="/index">首页</a>
	  			</li>
	  			<li>
	  				<a href="">帮助中心</a>
	  			</li>
	  		</ul>
	  	</div>
	  </div>
		<div class="content">
			<div class="maincenter">
				<div>
					<el-steps :active="step" align-center process-status="finish" finish-status="success" class="authc-steps">
						<el-step title="验证身份"></el-step>
						<el-step :title="ivActionType"></el-step>
						<el-step title="完成"></el-step>
					</el-steps>
				</div>
				<div class="maincenter-box">
					<div style="width: 80%;margin:0 auto;font-size: 14px;border-bottom: 1px solid #b9b9b9;">请完成以下操作，重置账号<span style="color: #00B7D3;">{{$store.state.username}}</span>密码</div>
					<div class="form">
						<div class="form-phone">
						  <div class="form-phone-item form-item-L">新密码 :</div>
						  <div class="form-phone-item form-item-M">
							<el-popover placement="right" trigger="focus" width="280">
							  <el-input v-model="password" type="password" @blur="verifyPassword" slot="reference"
							            placeholder="设置你的登录密码" class="form-password"></el-input>
							  <div class="input-hint">
							    <div>
							      <right-or-wrong-icon :res="passwordVerify['len']"></right-or-wrong-icon>
							      密码长度6-20字符
							    </div>
							    <div>
							      <right-or-wrong-icon :res="passwordVerify['char']"></right-or-wrong-icon>
							      只能包含字母、数字及标点符号（不包括空格）
							    </div>
							    <div>
							      <right-or-wrong-icon :res="passwordVerify['count']"></right-or-wrong-icon>
							      字母、数字和标点符号至少包含2种
							    </div>
							  </div>
							</el-popover>
						  </div>
						  <div class="form-phone-item form-item-R">
							  <div class="errmsg">{{ errmsg['pwd'] }}</div>
						  </div>
						</div>
						<div class="form-phone">
						  <div class="form-phone-item form-item-L">再输一遍 :</div>
						  <div class="form-phone-item form-item-M">
							<el-popover placement="right" trigger="focus" width="240">
							  <el-input v-model="password1" slot="reference" @blur="verifyRepetitivePassword"
							            type="password" placeholder="请再次输入你的密码" class="form-password"></el-input>
							  <div class="input-hint">请再次输入你的密码</div>
							</el-popover>
						  </div>
						  <div class="form-phone-item form-item-R">
							  <div class="errmsg">{{ errmsg['pwd1'] }}</div>
						  </div>
						</div>
						<div class="form-phone">
						  <div class="form-phone-item form-item-M submitButton">
							<el-button type="primary" @click="submitHandler">确认</el-button>
						  </div>
						  <div class="form-phone-item form-item-R">
							<span>其他验证方式</span>
						  </div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<footer-layout></footer-layout>
	</div>
</template>

<script>
  import BaseUserInfo from '@/components/form/BasicInfoForm'
  import RightOrWrongIcon from '@/components/fields/RightOrWrongIcon'
  import AddrThreeSelect from '@/components/fields/AddrThreeSelect'
  import FooterLayout from '@/components/layout/FooterLayout'
  export default {
    name: 'FindPassword',
    components: {FooterLayout,AddrThreeSelect, BaseUserInfo, RightOrWrongIcon},
    data() {
      return {
		step: 1,
		ivActionType: '找回密码',
		password: '',
		password1: '',
		formKey: '',
		safety: '',
		passwordVerify: [],
		errmsg: [],
        industries: [],
        errors: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
        formData: {
          name: '',
          idcard: '',
          addr: '',
          industry: '',
        },
      }
    },
	watch: {
	  password(nv, ov) {
	    this.verifyPasswordFormat()
	  }
	},
    methods: {
	  /**
	   * 密码格式验证
	   * @returns {boolean}
	   */
	  verifyPasswordFormat() {
	    console.log('pwd change')
	    let res = true
	    // 长度检测
	    if (this.password.length < 6 || this.password.length > 20) {
	      res = false
	      this.$set(this.passwordVerify, 'len', false)
	    } else {
	      this.$set(this.passwordVerify, 'len', true)
	    }
	    // 字符检测
	    console.log(/^[0-9a-zA-Z!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$/.test(this.password))
	    if (/^[0-9a-zA-Z!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$/.test(this.password)) {
	      this.$set(this.passwordVerify, 'char', true)
	    } else {
	      res = false
	      this.$set(this.passwordVerify, 'char', false)
	    }
	    // 字符种类检测
	    let rex = /^(?![a-zA-Z]+$)(?!\d+$)(?![!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$)[0-9a-zA-Z!@#$%^&*()_\-+={\[}\]|\\<,>.?/]+$/
	    if (rex.test(this.password)) {
	      this.$set(this.passwordVerify, 'count', true)
	    } else {
	      res = false
	      this.$set(this.passwordVerify, 'count', false)
	    }
	    return res
	  },
	  /**
	   * 验证密码
	   * @param nonEmpty
	   * @returns {boolean}
	   */
	  verifyPassword(nonEmpty) {
	    if (nonEmpty !== true && this.password === '') {
	      this.$set(this.errmsg, 'pwd', '')
	      return true
	    }
	    // 非空检测
	    if (this.password === '') {
	      this.$set(this.errmsg, 'pwd', '请设置登录密码')
	      return false
	    }
	    if (this.verifyPasswordFormat() === false) {
	      this.$set(this.errmsg, 'pwd', '密码设置不符合要求')
	      return false
	    }
	    this.$set(this.errmsg, 'pwd', '')
	    return true
	  },
	  /**
	   * 验证密码
	   * @param nonEmpty
	   * @returns {boolean}
	   */
	  verifyRepetitivePassword(nonEmpty) {
	    if (nonEmpty !== true && this.password1 === '') {
	      this.$set(this.errmsg, 'pwd1', '')
	      return true
	    }
	    if (this.password1 === '') {
	      this.$set(this.errmsg, 'pwd1', '请再次输入你的密码')
	      return false
	    }
	    if (this.password !== this.password1) {
	      this.$set(this.errmsg, 'pwd1', '两次输入的密码不一致，请重新输入')
	      return false
	    }
	    this.$set(this.errmsg, 'pwd1', '')
	    return true
	  },
	  verifyForm() {
	    let res = true
	    // 验证密码
	    res = this.verifyPassword(true) && res
	    // 重复密码验证
	    res = this.verifyRepetitivePassword(true) && res
	    return res
	  },
      submitHandler() {
		if (this.verifyForm() === false) {
		  return
		}
		this.$api.user.findPassword(this.safety, this.password).then(res => {
		  // 1030 formKey过期 1012 验证码错误
		  if (res.code === 0) {
			  this.$router.push({path:'/finishreset'})
		  //   this.smsError = ''
		  } else {
		    let msg = res.msg
		    if (res.details) {
		      msg += ',' + res.details
		    }
		    this.$message.error(msg)
		  }
		})
      },
    },
    created() {
	  this.safety = this.$route.query.safety
    }
  }
</script>

<style>
.form-password .el-input__inner{
	border-radius: 0px;
}
</style>

<style scoped>
  .authc-steps {
    margin-top: 40px;
  	margin-bottom: 30px;
  }
  .safe .content{
  	width: 990px;
  	/* height: 1050px; */
  	margin: 0 auto;
  	font-size: 12px;
  }
  .maincenter-box .form{
  	padding: 0px 5px 20px 120px;
  }
  .maincenter-box {
  	margin: 0 auto;
  	padding: 20px 0;
  	width: 774px;
  	height: auto;
  }
  .form{
  	  margin-top: 20px;
  }
  .form-item-L {
  	  width: 70px;
  	  margin-right: 20px;
  	  text-align: right;
  	  font-size: 14px;
  }
  .form-item-M {
  	  
  }
  .form-item-M .el-button{
  	  width: 150px;
  	  /* line-height: 18px; */
  	  font-size: 12px;
  	  border-radius: 2px;
  	  margin-left: 90px;
  	  margin-right: 10px;
  }
  .form-item-R .el-button{
  	  border: 1px solid #FF751A;
  	  background-color: #FFF1E8;
  	  color: #FF751A;
  }
  .form-item-R span{
  	  color: #9B9EA0;
  	  cursor: pointer;
  }
  .form-item-R:hover span{
  	  color: #02b2f8;
  }
  .bottom-tips {
  	  margin: 0 auto;
  	  width: 774px;
  	  height: auto;
  }
  
  .form-divider{
  	  margin: 10px 0 30px 0;
  }
  
  .form-input{
  	  /* font-size: 12px; */
  	  width: 110px;
  	  margin-right: 10px;
  }
  .form-hint {
    padding: 5px 0;
    margin-bottom: 20px;
    border: 1px solid #eee;
    background: #eee;
    text-align: center;
    color: #666;
    border-radius: 2px;
  }
  
  .errmsg {
    color: red;
  	margin-left: 20px;
  }
  
  .form-phone {
  	  height: 56px;
  }
  .form-phone-item{
  	  line-height: 36px;
  	  float: left;
  }
  .form-phone-item .el-button{
  	  height: 36px;
  	  /* line-height: 18px; */
  	  font-size: 12px;
  	  border-radius: 2px;
  }
  .footer {
  	 text-align: center;
  	 width: 120px;
  	 margin: 30px auto;
  }
</style>
